import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../AccessControl/AccessControlTypes';
import { Data, NeoModel } from '@singularsystems/neo-core';
import ProvisionalTaxReportsSearchCriteria from '../Models/Queries/ProvisionalTaxReportsSearchCriteria';
import InterestWithholdingTaxLookup from '../Models/Lookups/InterestWithholdingTaxLookup';
import ProvisionalTaxReportsApiClient from '../../ApiClients/ProvisionalTaxReportsApiClient';

export default class InterestWithholdingTaxVM extends Views.ViewModelBase {
  public provisionalTaxReportsSearchCrtieria: ProvisionalTaxReportsSearchCriteria = new ProvisionalTaxReportsSearchCriteria();
  public interestWithholdingTaxPageManager = new Data.PageManager(this.provisionalTaxReportsSearchCrtieria, InterestWithholdingTaxLookup,
     this.provisionalTaxReportsApiClient.getInterestWithholdingTaxPagedList, {
        pageSize: 10, 
        sortAscending: true,
        fetchInitial: false,
        sortBy: "eventDate",
        initialTaskRunner: this.taskRunner,
     }
   );
    constructor(
      taskRunner = AppService.get(Types.Neo.TaskRunner),
      private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
      private provisionalTaxReportsApiClient = AppService.get(Types.ApiClients.ProvisionalTaxReportsApiClient)) {
      super(taskRunner);
    } 

    public async initialise() {
    }

    public search(searchCriteria: ProvisionalTaxReportsSearchCriteria) {
      this.provisionalTaxReportsSearchCrtieria.mapFrom(searchCriteria);   
    }
}